export default {
    title: "收藏夾",
    search1: "全選",
    search2: "刪除",
    search3: "返回",
    search4: "批量操作",
    place: "商品搜索",
    tab: "我的收藏",
    addCart: "加入購物車",
    nothing: "暫無商品，快去收藏吧！",
    errmsg: "您還未選中商品！",
}